import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CoreButton, CoreNavigation } from 'src/components/core'
import { useTabList } from './useTabList'
import { Icon } from '@iconify/react'
import { useParams, useHistory } from 'react-router-dom'
import { track } from '@amplitude/analytics-browser'
import { getUserLimits } from 'src/api/limit'
import { LimitTypeEnum } from 'src/model/limit'
import { withStyles } from '@material-ui/core'
import LimitReachedModal from 'src/components/limit-reached-modal'
import { AssignmentTypes } from 'src/model/assignment'
import styles from './styles'
const PageSelector = ({ loading, classes }) => {
  const dispatch = useDispatch()
  const entity = useSelector(state => state.collection.collection)

  const { tabList } = useTabList(dispatch)
  const { id, page } = useParams()
  const history = useHistory()
  const [isUserReachedCourseLimit, setIsUserReachedCourseLimit] = useState(
    'Initial',
  )
  const [isLoadingLimit, setIsLoadingLimit] = useState(true)

  useEffect(() => {
    const checkUserLimits = async () => {
      try {
        setIsLoadingLimit(true)
        const response = await getUserLimits()
        let count = response.data.find(
          x => x.limit.type == LimitTypeEnum.CourseCreation,
        ).count

        let limit = response.data.find(
          x => x.limit.type == LimitTypeEnum.CourseCreation,
        ).limit.upperLimit

        count >= limit && limit != -1
          ? setIsUserReachedCourseLimit(true)
          : setIsUserReachedCourseLimit(false)
      } catch (error) {
        console.error('Error checking user limits:', error)
        setIsUserReachedCourseLimit(false)
      } finally {
        setIsLoadingLimit(false)
      }
    }
    checkUserLimits()
  }, [])
  const handleRedirect = () => {
    if (isLoadingLimit) {
      setModalOpen(true)
      return
    }
    track('create_course_button_clicked')
    history.push('/create-course-selection?collectionId=' + id)
  }
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className={classes.root}>
      <CoreNavigation
        tabList={tabList}
        color="secondary"
        backgroundColor="primary"
        size="small"
        disabled={loading}
      />
      {page == 'mini-courses' && (
        <CoreButton
          startIcon={<Icon icon="lineicons:plus" />}
          variant="contained"
          size="small"
          onClick={handleRedirect}
        >
          Create mini course
        </CoreButton>
      )}
      {modalOpen && (
        <LimitReachedModal
          dispatch={dispatch}
          id={id}
          entity={entity}
          history={history}
          handleCloseModal={() => setModalOpen(false)}
          isModalOpen={modalOpen}
          collectionName={entity.name}
          selectedAssignmentType={AssignmentTypes.ONETIME}
        />
      )}
    </div>
  )
}

export default withStyles(styles)(PageSelector)
